<template>
  <Drawer
    width="400"
    :title="`${openedSales ? '编辑' : '新增'}销售`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="客户" prop="customer" style="width: 366px">
          <Select
            v-model="formItem.customer"
            filterable
            clearable
            :loading="customerLoading"
            style="width: 366px"
          >
            <Option
              v-for="option in customerList"
              :key="option._id"
              :value="option._id"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="产品" prop="material">
          <Select v-model="formItem.material" filterable clearable>
            <Option
              v-for="option in productList"
              :key="option._id"
              :value="option._id"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="名字" prop="name">
          <Input
            v-model="formItem.name"
            placeholder="例如：长青深圳站 保坍减水剂"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "CreateSalesDrawer",
  computed: {
    ...mapState({
      customerList: (state) => state.customer.customers,
      sac: (state) => state.sac.sac,
    }),
    ...mapGetters({
      productList: "material/productMateral",
    }),
  },
  data() {
    return {
      drawerOpened: false,
      openedSales: null,
      customerLoading: false,
      searchCustomerList: [],
      newCusName: null,
      formItem: {
        customer: null,
        material: null,
        name: null,
      },
      ruleValidate: {
        customer: [
          { required: true, message: "客户为必填项", trigger: "submit" },
        ],
        material: [
          { required: true, message: "产品为必填项", trigger: "submit" },
        ],
        name: [{ required: true, message: "名字为必填项", trigger: "submit" }],
      },
    };
  },
  methods: {
    ...mapActions({
      getMaterial: "material/getMaterialsAction",
      createSacSales: "sac/createSacSalesAction",
      updateSacSales: "sac/updateSacSalesAction",
      getSalesList: "sac/getSalesListAction",
    }),
    async openDrawer(sales) {
      this.$refs["formItem"].resetFields();
      this.openedSales = null;
      if (sales) {
        this.openedSales = sales; // 如果有打开，则为编辑模式
        this.formItem.name = sales.name;
        this.formItem.customer = sales.customer._id;
        this.formItem.material = sales.material._id;
      }
      this.drawerOpened = true;
      this.newCusName = null;
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSales) {
              await this.updateSacSales({
                id: this.openedSales._id,
                data: this.formItem,
              });
            } else {
              await this.createSacSales({
                ...this.formItem,
                sacId: this.sac._id,
              });
            }
            this.$Message.success("保存成功!");
            this.$emit("editSuccess");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
